<template>
  <div>
    <div>
      <div class="row bottom-border"  v-if="hasData && !loading">
        <span class="header status">Status</span>
        <span class="header invoice-number">Invoice</span>
        <span class="header total-amount text-right">Amount</span>
        <span class="header due-date text-center">Due Date</span>
        <span class="header supplier-name text-left">Supplier</span>
      </div>
      <div class="scroller" v-if="hasData">
        <div>
          <div v-for="(item, i) in items"
               :key="i"
               class="row">
            <span class="status"><span :title ="item.InvoiceStatus" :class="{'indicator': true, 'red': (item.InvoiceStatus.indexOf('Overdue') !== -1)}">{{item.InvoiceStatus}}</span></span>
            <span class="invoice-number" :title="item.InvoiceNumber">
              <a 
                :href="item.InvoiceUrl"
                @click="handleClick(item)">
                {{item.InvoiceNumber}}
              </a>
            </span>
            <span class="total-amount text-right" :title="item.TotalAmount">{{item.TotalAmount}}</span>
            <span class="due-date text-center" :title="item.DueDate">{{item.DueDate}}</span>
            <span class="supplier-name text-left" :title="item.SupplierName">
              <a v-if='item.SupplierUrl !== null' :href="item.SupplierUrl">{{item.SupplierName}}</a>
              <a v-else class="no-link">{{item.SupplierName}}</a>
            </span>
          </div>
        </div>
      </div>

      <div class="empty-holder" v-if='this.loading'>
        <span class="inv-loading" /> Loading current invoices ...
      </div>

      <div class="empty-holder" v-if='!hasData && !this.loading'>
        <i class="fal fa-list" />
        <span>
          <p class="bold">No Invoices Found</p>
          <p class="light">No invoices are currently open</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { initScrollbar } from '../../helpers/scrollbarHelper.js'
  import { EventBus } from '@/event-bus'

  export default {
    alias: 'current-invoices-wdg-cmp',

    props: { widget: Object },

    data() {
      return {
        items: [],
        loading: false
      }
    },

    computed: {
      hasData() {
        if ((this.items !== null) && (this.items.length > 0)) return true
        else return false
      }
    },

    methods: {
      handleClick(item) {
        const isEmbedded = window.self !== window.top
        if (isEmbedded) {
          window.parent.postMessage(
            {
              type: 'LEGACY_INVOICE_CLICK',
              invoiceId: item.PaymentInvoiceId
            },
            '*'
          )
          return
        }
      }
    },

    created() {
      this.loading = true

      this.api.get(this.widget.endPoint, {})
        .then(r => {
          this.items = r.data.items
        })
        .finally(() => {
          this.loading = false

          this.$nextTick(() => {
            let desiredHeight = !this.hasData ? 1 : getDesiredSize(this.items.length)

            EventBus.$emit('updateWidgetHeight', {
              wId: this.widget.id,
              height: desiredHeight,
              alt: -1
            })
            if (this.items.length > 6) {
              this.$el.querySelector('.scroller').style.height = '156px'
              initScrollbar(this, '.scroller')
            }
          })
        })
    }
  }

  function getDesiredSize(len) {
    let res = 1
    if (len >= 6) return 3
    switch (len) {
      case 1: res = 1
        break
      case 2:
      case 3: res = 2
        break
      case 4:
      case 5: res = 3
        break
    }
    return res
  }

</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";

  .scroller {
    position: relative;
    overflow-y: hidden;
  }

  .header {
    text-transform: uppercase;
    font-weight: 600;
  }

  .empty-holder {
    text-align: center;
  }

  .inv-loading{
      margin-top: 25px;
      margin-left: 55px;
  }
  a[href] {
    color: $href-blue-color
  }
  div.empty-holder {
    position: absolute;
    left: 170px;
    i.fal {
      font-size: 1.7rem;
      height: 50px;
      width: 50px;
      padding-top:11px;
      padding-left:1px;
      background-color:#f2f2f2;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
    text-align: center;
    margin-top: 0px;
    color: #9c9c9c;
    font-size: 0.96em;
    font-weight: 600;
    span{
      text-align: left;
      display: inline-block;
      p{
        line-height: 0.4rem;
        display:block;
        &.bold{
          font-weight: 650
        }
        &.light{
          font-size: 0.8rem;
          font-weight: 200;
        }
      }
    }
  }

  .indicator {
    border-radius: 5px;
    padding: 1px 4px;
    font-size: 0.75rem;
    border: 1px solid $main-black;
    background-color: white;
    color: $main-black;
    font-weight: 100;
    line-height: 1.2em;
    position: absolute;
    top: 0.1em;
    max-width: 18%;
  }
  .red {
    border: 1px solid $indicator-red;
    background-color:$indicator-red;
    color: white;
    font-weight: 400;
  }

  .row {
    &.bottom-border{
          @include theme {
      border-bottom: 1px solid v(background-light);
      }
      margin-bottom:3px;
    }
    clear: both;
    font-size: $font-size-xsmall;
    line-height: 1.7em;
    padding: 0 1.5em 0 .6em;
    position:relative;
  }

  .row span {
    margin-top: 0.5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .status {
    display: inline-block;
    width: 20%;
    float: left;
    padding-right: 3px;
  }

  .invoice-number {
    display: inline-block;
    width: 21%;
    float: left;
    padding-right: 3px;
  }

  .total-amount {
    display: inline-block;
    width: 19%;
    float: left;
    padding-right: 3px;
  }

  .due-date {
    display: inline-block;
    width: 14%;
    float: left;
    padding-right: 3px;
  }

  .supplier-name {
    display: inline-block;
    width: 25%;
    float: left;
  }
  a.no-link{
    @include theme {
      color: v(ink);
    }
  }

  .details {
    display: inline-block;
    width: 50%;
  }

    .details span {
      margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/CurrentInvoices/index.vue